import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import stores from './store';
import '@/assets/fontAwesome/scss/font-awesome.scss'

const app = createApp(App);
app.use(ElementPlus);
app.use(router);
app.use(stores);
 
//跳转前设置title
router.beforeEach((to, from, next) => { 
 
  const { title, keywords,description } = to.meta;
  if (title) { 
    document.title = title;
  }
  if (keywords) { 
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.content = keywords;
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'keywords');
      newMeta.setAttribute('content', keywords);
      document.head.appendChild(newMeta);
    }
  }
  if (description) { 
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.content = description;
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'description');
      newMeta.setAttribute('content', description);
      document.head.appendChild(newMeta);
    }
  } 
  
  next();
});
  //跳转后设置scroll为原点
router.afterEach((to, from) => {
    window.scrollTo(0, 0);
    console.log("======"+from.path+to.path);
}); 

app.config.globalProperties.$local= window.localStorage;
app.config.globalProperties.$session = window.sessionStorage;

app.mount('#app');